export const askQuestionsPage = {
    stepMakeQuestion: {
        title: 'Call if you have any questions – your call will be treated with confidentiality.',
        subtitleInfo1: 'Please also check our ',
        faq: 'FAQ',
        subtitleInfo2: ', where you can find answers to questions about the ',
        subtitleInfo3: ' whistleblower scheme.',
    }
};
